<template>
    <modal class="promotionalSelectModel" :isShow="isShow" @keyup.esc="hide">
        <div class="header">参与活动选择</div>
        <div class="modal-body">
            <div class="title">本次点单触发了{{data.length>1?'多个':''}}优惠活动，请选择</div>
            <div class="list-box">
                <div class="li-box" :class="{selected:selectPromotion?.PromAutoid==item.PromAutoid}" 
                    @click="clickProm(item)"
                    v-for="item in data" :key="item">
                    <div class="tag">{{item.PromKindName}}</div>
                    <div class="name verticalCenter">
                        <div class="text inlineNowrap2">{{item.PromotionName}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-box">
            <button class="btn" @click="hide()">返回</button>
            <button class="btn btn-giveup" @click="cancel()">放弃优惠活动</button>
            <button class="btn btn-confirm" @click="confirm()">确定</button>
        </div>
    </modal>
</template>
  
<script>
export default {
    emits:["close","cancel","confirm"],
    name:'promotionalSelectModel',
    props:{
        isShow:{
            type:Boolean,
            dafault:false
        },
        /**
         * 传入的数据 
         * 
        */
        data:{
            type:Object,
            dafault:null
        },
        /**选中的一个优惠活动id */
        promAutoid:{
            type:String,
            dafault:null
        }
    },
    data(){
        return{
            //选中的方案
            selectPromotion:null
        }
    },
    watch:{
        isShow(newVal){
            if(newVal){
                this.$nextTick(()=>{
                    this.setPromotion();
                })
            }
        }
    },
    mounted(){
        this.$nextTick(()=>{
           this.setPromotion();
        })
    },
    methods:{
        hide(){
            this.$emit("close");
        },
        clickProm(item){
            this.selectPromotion=item;
            if(this.data.length==1){
                this.confirm();
            }
        },
        /**选中 优惠活动 */
        setPromotion(){
            if(this.promAutoid && this.data?.length>0){
                this.selectPromotion=this.data.find(it=>it.PromAutoid==this.promAutoid);
            }
        },
        //放弃优惠活动
        cancel(){
            this.$emit("cancel");
        },
        //确认
        confirm(){
            if(!this.selectPromotion){
                this.$message.warning('请选择一种优惠活动!');
                return;
            }
            this.$emit("confirm",Object.assign({},this.selectPromotion));
        }
    }
}
</script>
<style lang="scss">
    @import "./promotionalSelectModel.scss"
</style>